import type { FormEvent, FunctionComponent } from 'react';

//  Prevents the form from submitting when the user hits ENTER.
function withPreventDefault(onSubmit: () => void) {
  return function handleSubmit(event: FormEvent<HTMLFormElement>): void {
    //  Prevent the default form submit action from happening, which refreshes the page.
    event.preventDefault();
    //  Prevent event bubbling/events firing twice (since clicking the submit button will call this fn anyway).
    event.stopPropagation();
    onSubmit();
  };
}

type AuthFormContainerProps = {
  onSubmit: () => void;
};

/**
 * Top-level <form> wrapper for the authentication form.
 *
 * @param {React.ReactNodeArray} children - Form contents.
 */
const AuthFormContainer: FunctionComponent<AuthFormContainerProps> = ({ children, onSubmit }) => (
  <form
    className="fossa-auth__form"
    onSubmit={withPreventDefault(onSubmit)}
  >
    {children}
  </form>
);

export default AuthFormContainer;
